import { render, staticRenderFns } from "./SignInBtnGoogle.vue?vue&type=template&id=5ae6a002&"
import script from "./SignInBtnGoogle.vue?vue&type=script&lang=js&"
export * from "./SignInBtnGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports